import React, { Component } from "react";
import styles from "./styles.scss";
import CSSModules from "react-css-modules";
import PropTypes from "prop-types";
import { actions } from "./redux";
import { connect } from "react-redux";

import { Search } from "@material-ui/icons";

/*

Use:
    props searchBarId = a unique name
    timeout = a delay on typeahead. optional
    noTypeahead = optional
	minChars = optional
	params = optional
	classes = optional parent scss import to override class names


*/

class SearchBar extends Component {
	static defaultProps = {
		inputClass: "",
		inputWrapClass: "",
		iconClass: ""
	};
	static propTypes = {
		params: PropTypes.object,
		timeout: PropTypes.number,
		noTypeahead: PropTypes.bool,
		minChars: PropTypes.number,
		searchBarId: PropTypes.string.isRequired,
		inputClass: PropTypes.string,
		inputWrapClass: PropTypes.string,
		containerClass: PropTypes.string,
		classes: PropTypes.object //style overrides
	};

	constructor(props) {
		super(props);
		this.state = {
			text: ""
		};
	}

	cancel = null;

	delay(ms, query) {
		//cancel any pending promises
		if (this.cancel) {
			this.cancel();
			this.cancel = null;
		}
		const prom = new Promise((resolve, reject) => {
			this.cancel = reject;
			setTimeout(() => {
				if (this.cancel == reject) {
					resolve();
				} else {
					reject();
				}
			}, ms);
		});

		prom.then(
			() => {
				if (!this.props.minChars || query.length >= this.props.minChars) {
					this.props.searchTextChanged(
						{ text: query, searchBarId: this.props.searchBarId },
						this.props.params
					);
				}
			},
			() => {
				/*rip*/
			}
		);
	}

	onTextChange(text) {
		this.setState({ text });

		if (!this.props.noTypeahead) {
			if (this.props.timeout) {
				this.delay(this.props.timeout, text);
			} else {
				this.props.searchTextChanged({ text, searchBarId: this.props.searchBarId }, this.props.params);
			}
		}
	}

	search(text) {
		if (this.cancel) {
			this.cancel();
			this.cancel = null;
		}
		if (!this.props.minChars || text.length >= this.props.minChars) {
			this.props.submit({ text, searchBarId: this.props.searchBarId }, this.props.params);
		}
	}

	render() {
		return (
			<div styleName={`_inputWrap ${this.props.inputWrapClass}`}>
				<input
					styleName={`_input ${this.props.inputClass}`}
					placeholder="Search"
					id={this.props.searchBarId}
					value={this.state.text}
					onChange={e => {
						this.onTextChange(e.target.value);
					}}
					onKeyPress={e => {
						if (e.key === "Enter") {
							e.preventDefault();
							this.search(this.state.text);
						}
					}}
				/>

				<Search styleName={`black ${this.props.iconClass}`} onClick={() => this.search(this.state.text)} />
			</div>
		);
	}
}

const bindAction = dispatch => {
	return {
		searchFocusChanged: data => dispatch(actions.searchFocusChanged(data)),
		searchTextChanged: (data, params) => dispatch(actions.searchTextChanged(data, params)),
		submit: (data, params) => dispatch(actions.searchSubmit(data, params))
	};
};

const mapStateToProps = state => ({
	query: state.cSearch.query,
	isSearching: state.cSearch.isSearching,
	thissearchBarId: state.cSearch.searchBarId
});

//do this to merge classes
export default class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			wrapped: null
		};
	}

	componentWillMount() {
		if (this.props.searchBarId === undefined) {
			throw "Searchbar must have 'searchBarId' prop set.";
		}
		this.setState({
			wrapped: connect(mapStateToProps, bindAction)(
				CSSModules(
					SearchBar,
					{ ...styles, ...this.props.classes },
					{
						allowMultiple: true
					}
				)
			)
		});
	}

	render() {
		const Elem = this.state.wrapped;
		return <Elem {...this.props} />;
	}
}



// WEBPACK FOOTER //
// ./src/components/SearchBar/SearchBar.js